import React, {lazy, Suspense, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import {Spinner} from '../spinner';
import Layout from './layout';
import requireAuth from 'feedback-system/auth/requiresAuth';
import {fetchUserProfile} from 'feedback-system/auth/actions';
import {authSelector} from '../../auth/selectors';
import {redirectToLoginPage} from '../../utils';
import {Role} from '../../dto/UserDto';

const QualityFeedback = lazy(() => import('../quality-feedback'));
const UserProfile = lazy(() => import('../user-profile'));
const NotFound = lazy(() => import('../not-found'));

const FeedbackConsolidationLazy = lazy(() => import('../feedback-consolidation'));
const FeedbackOverviewLazy = lazy(() => import('../feedback-overview'));
const EmployeesLazy = lazy(() => import('../employees'));
const AdminLazy = lazy(() => import('../admin'));
const SettingsLazy = lazy(() => import('../settings'));

const FeedbackConsolidation = requireAuth(FeedbackConsolidationLazy, [Role.MANAGER]);
const FeedbackOverview = requireAuth(FeedbackOverviewLazy, [Role.USER]);
// const Employees = requireAuth(EmployeesLazy, [Role.USER]);
const Admin = requireAuth(AdminLazy, [Role.ADMIN]);
const Settings = requireAuth(SettingsLazy, [Role.ADMIN, Role.MANAGER]);

const MainContainer = () => {
    const dispath = useDispatch();
    const {user} = useSelector(authSelector);

    useEffect(() => {
        const data = localStorage.getItem('accessToken');
        if (!data) {
            redirectToLoginPage();
        } else {
            dispath(fetchUserProfile());
        }
    }, [dispath]);

    return (
        <Layout>
            {user ? (
                <Suspense fallback={<Spinner />}>
                    <Switch>
                        <Route path="/" component={QualityFeedback} exact={true} />
                        <Route path="/feedback-consolidation" component={FeedbackConsolidation} />
                        {/* <Route path="/employees" component={Employees} /> */}
                        <Route path="/admin" component={Admin} />
                        <Route path="/feedback-overview" component={FeedbackOverview} />
                        <Route path="/settings" component={Settings} />
                        <Route path="/profile" component={UserProfile} />
                        <Route component={NotFound} />
                    </Switch>
                </Suspense>
            ) : (
                <Spinner />
            )}
        </Layout>
    );
};

export default MainContainer;
